import { createSlice, createDraftSafeSelector, createAsyncThunk } from '@reduxjs/toolkit';
import { render as renderApi } from '../lib/api';

export const fetchCompositeStyling = createAsyncThunk('fitting/fetchCompositeStyling', async data => {
  try {
    const response = await renderApi(data);
    return response;
  } catch (err) {
    throw err.response?.data?.error || err;
  }
});

const initialState = {
  loading: 'idle',
  actionResult: '',
  compositeImages: {
    images: ['/static/images/defaultnike.png'],
  } /* default image to display before selecting fitting options */,
  error: '',
};

const reducers = {
  compositeReset: () => {
    return { ...initialState };
  },
};

const extraReducers = {
  [fetchCompositeStyling.pending]: state => {
    if (state.loading === 'idle') {
      state.loading = 'pending';
      state.actionResult = 'REQ';
    }
  },
  [fetchCompositeStyling.fulfilled]: (state, action) => {
    if (state.loading === 'pending') {
      state.loading = 'idle';
      state.actionResult = 'SUCCESS';
      state.compositeImages = action.payload;
      state.error = '';
    }
  },
  [fetchCompositeStyling.rejected]: (state, action) => {
    if (state.loading === 'pending') {
      state.loading = 'idle';
      state.actionResult = 'FAILURE';
      state.compositeImages = [];
      state.error = action.error;
    }
  },
};

export const fitting = createSlice({
  name: 'fitting',
  initialState,
  reducers: reducers,
  extraReducers: extraReducers,
});

export const FITTING = fitting.name;
export const fittingReducer = fitting.reducer; /* reducer */
export const { compositeReset } = fitting.actions; /* export reducer actions */

/* create selector */
const selectCompositeImages = createDraftSafeSelector(
  state => state.compositeImages,
  state => state.actionResult,
  state => state.loading,
  state => state.error,
  (compositeImages, actionResult, loading, error) => ({
    compositeImages,
    actionResult,
    loading,
    error,
  })
);

export const fittingSelector = {
  compositeImagesState: state => selectCompositeImages(state[FITTING]),
};
